import "./style.scss";

const RatingProgress = ({ rating, color }) => {
	const Color = color ? color : "#2368a2";
	const value = (rating / 5) * 100;
	return (
		<div className="rating-progress">
			<div
				className="progress"
				style={{ width: value + "%", background: Color }}
			></div>
		</div>
	);
};

export default RatingProgress;
